import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-900">
              最新吃瓜爆料
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">
              每日更新，追踪热点，不放过任何一个大瓜
            </p>
          </div>
          <Link
            to="/article/chigua-2026-0706"
            className="text-sm text-primary-500 hover:text-primary-600 font-label font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-label font-semibold backdrop-blur-sm">
                  {article.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-foreground-900 text-base leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-foreground-500 text-sm line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.readCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {article.commentCount.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}